export enum Shape {
  circle = 'circle',
  square = 'square'
}
